module.exports = __webpack_public_path__ + "media/images/logo_triangle-c442ec69.png";